export type NavContext = {
  isLoggedIn: boolean;
  isAdmin: boolean;
  isExec: boolean;
  isProspect: boolean;
};

export type NavItem = {
  label: string;
  to: string;
  kind?: 'link' | 'action';
};

export function getPrimaryNavItems(ctx: NavContext): NavItem[] {
  if (!ctx.isLoggedIn) {
    return [
      { label: 'Home', to: '/' },
      { label: 'Members', to: '/members' },
      { label: 'Events', to: '/events' },
      // NOTE: Apply/Join is intentionally *not* in the unauthenticated menu.
      // The apply CTA lives on `/`.
      { label: 'Login', to: '/login' },
    ];
  }

  const items: NavItem[] = [
    { label: 'Home', to: '/' },
    { label: 'Members', to: '/members' },
    { label: 'Events', to: '/events' },
  ];

  if (!ctx.isProspect) {
    items.push({ label: 'Settings', to: '/settings' });
  }

  if (ctx.isExec) {
    items.push({ label: 'Executive', to: '/executive' });
  }

  if (ctx.isAdmin) {
    items.push({ label: 'Admin', to: '/admin' });
  }

  if (ctx.isProspect) {
    items.push({ label: 'Prospect', to: '/prospect' });
  }

  items.push({ label: 'Logout', to: '#', kind: 'action' });

  return items;
}
